import { render, staticRenderFns } from "./FormDrawer.vue?vue&type=template&id=cfee50f0&scoped=true&lang=pug&"
import script from "./FormDrawer.vue?vue&type=script&lang=js&"
export * from "./FormDrawer.vue?vue&type=script&lang=js&"
import style0 from "./FormDrawer.vue?vue&type=style&index=0&id=cfee50f0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfee50f0",
  null
  
)

/* custom blocks */
import block0 from "./FormDrawer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports